import type { CompositionKind } from 'types/composition';
import type { ComposerGalleryKindFilter } from './ComposerGalleryOrganism';

export type ComposerGalleryAddAction =
  | { type: 'space' }
  | { type: 'composition'; kind: CompositionKind }
  | { type: 'menu' }
  | { type: 'none' };

/**
 * Derives which "New …" affordance the gallery toolbar renders from the active kind facet
 * (EAINT-844 Phase F7b). `'all'` collapses to a single "New ▾" menu over the four creatable kinds;
 * a single facet gets its one matching type-aware action; the Built-ins facet (`'primitive'`, see
 * `gallerySections.ts`) gets none — built-ins are code-defined and cannot be created (owner's
 * no-clone rule).
 */
export function resolveGalleryAddAction(kindFilter: ComposerGalleryKindFilter): ComposerGalleryAddAction {
  switch (kindFilter) {
    case 'all':
      return { type: 'menu' };
    case 'space':
      return { type: 'space' };
    case 'surface':
    case 'section':
    case 'fragment':
      return { type: 'composition', kind: kindFilter };
    default:
      return { type: 'none' };
  }
}
